var map = {
  "./km.json": [
    "408445",
    "947803"
  ],
  "./ru.json": [
    "651393",
    "626953"
  ],
  "./bg.json": [
    "992312",
    "195218"
  ],
  "./el.json": [
    "734978",
    "407209"
  ],
  "./en-pt.json": [
    "336400",
    "835403"
  ],
  "./ja.json": [
    "105408",
    "467007"
  ],
  "./ar.json": [
    "584524",
    "792039"
  ],
  "./rw.json": [
    "178801",
    "206715"
  ],
  "./sr.json": [
    "412932",
    "211528"
  ],
  "./lol.json": [
    "944679",
    "832421"
  ],
  "./fr.json": [
    "186443",
    "659423"
  ],
  "./sv.json": [
    "869974",
    "40565"
  ],
  "./as.json": [
    "565002",
    "362653"
  ],
  "./gu.json": [
    "280846",
    "548215"
  ],
  "./kk.json": [
    "329760",
    "100498"
  ],
  "./nb.json": [
    "854121",
    "138106"
  ],
  "./ta.json": [
    "737804",
    "67966"
  ],
  "./ky.json": [
    "846242",
    "587928"
  ],
  "./pl.json": [
    "722523",
    "537777"
  ],
  "./ro.json": [
    "951526",
    "552347"
  ],
  "./ka.json": [
    "293300",
    "509728"
  ],
  "./hu.json": [
    "266126",
    "49866"
  ],
  "./uk.json": [
    "163624",
    "772905"
  ],
  "./or.json": [
    "977349",
    "584307"
  ],
  "./uz.json": [
    "908290",
    "915378"
  ],
  "./hy.json": [
    "976611",
    "445728"
  ],
  "./de.json": [
    "554117",
    "63421"
  ],
  "./pt-pt.json": [
    "45718",
    "532195"
  ],
  "./es-cl.json": [
    "547528",
    "998148"
  ],
  "./vi.json": [
    "116560",
    "762254"
  ],
  "./tr.json": [
    "424153",
    "569316"
  ],
  "./da.json": [
    "600929",
    "166704"
  ],
  "./kn.json": [
    "425306",
    "607357"
  ],
  "./mr.json": [
    "228878",
    "410611"
  ],
  "./id.json": [
    "141916",
    "990036"
  ],
  "./lt.json": [
    "288280",
    "697034"
  ],
  "./lv.json": [
    "271729",
    "313139"
  ],
  "./fv.json": [
    "367513",
    "942939"
  ],
  "./zh-hans.json": [
    "978161",
    "698398"
  ],
  "./es.json": [
    "830674",
    "392991"
  ],
  "./ko.json": [
    "419118",
    "609817"
  ],
  "./te.json": [
    "872565",
    "796370"
  ],
  "./bn.json": [
    "770362",
    "747249"
  ],
  "./cs.json": [
    "244313",
    "258129"
  ],
  "./boxes.json": [
    "118575",
    "620859"
  ],
  "./my.json": [
    "593885",
    "762979"
  ],
  "./mn.json": [
    "296713",
    "475932"
  ],
  "./sk.json": [
    "992091",
    "236050"
  ],
  "./nl.json": [
    "370239",
    "351974"
  ],
  "./az.json": [
    "724495",
    "770504"
  ],
  "./accents.json": [
    "719126",
    "267334"
  ],
  "./pa.json": [
    "859184",
    "952882"
  ],
  "./pt.json": [
    "967091",
    "674318"
  ],
  "./extra.json": [
    "261818",
    "150943"
  ],
  "./it.json": [
    "366158",
    "975226"
  ],
  "./hi.json": [
    "688518",
    "945681"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 705706;
module.exports = webpackAsyncContext;
